export const serviceTypeEnum = {
  showFromMapAndServiceTypeForm: 1,
  showFromMapForm: 2,
  showServiceTypeForm: 3,
  showNone: 4,
};
